import React from 'react'

export default function Message ({ item, myselfIdentifier }) {
  if (item.author === myselfIdentifier) {
    return (
      <span>
        <strong>{item.author}:</strong> {item.message}
      </span>
    )
  } else {
    return (
      <>
        {item.author}: {item.message}
      </>
    )
  }
}
